// Form validation utilities

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password) => {
  // At least 6 characters
  return password.length >= 6;
};

export const validateRequired = (value) => {
  return value && value.trim().length > 0;
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[\d\s\-+()]+$/;
  return phoneRegex.test(phone) && phone.replace(/\D/g, '').length >= 10;
};

export const validateURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// Login form validation
export const validateLoginForm = (formData) => {
  const errors = {};

  if (!validateRequired(formData.email)) {
    errors.email = 'Email is required';
  } else if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email';
  }

  if (!validateRequired(formData.password)) {
    errors.password = 'Password is required';
  } else if (!validatePassword(formData.password)) {
    errors.password = 'Password must be at least 6 characters';
  }

  return errors;
};

// Signup form validation
export const validateSignupForm = (formData) => {
  const errors = {};

  if (!validateRequired(formData.fullName)) {
    errors.fullName = 'Full name is required';
  }

  if (!validateRequired(formData.email)) {
    errors.email = 'Email is required';
  } else if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email';
  }

  if (!validateRequired(formData.mobile)) {
    errors.mobile = 'Mobile number is required';
  } else if (!validatePhone(formData.mobile)) {
    errors.mobile = 'Please enter a valid mobile number (minimum 10 digits)';
  }

  if (!validateRequired(formData.password)) {
    errors.password = 'Password is required';
  } else if (!validatePassword(formData.password)) {
    errors.password = 'Password must be at least 6 characters';
  }

  return errors;
};

// Hotel onboarding validation
export const validateHotelStep1 = (formData) => {
  const errors = {};

  if (!validateRequired(formData.hotelName)) {
    errors.hotelName = 'Hotel name is required';
  }

  if (!validateRequired(formData.hotelManagerName)) {
    errors.hotelManagerName = 'Manager name is required';
  }

  if (!validateRequired(formData.category)) {
    errors.category = 'Category is required';
  }

  if (!validateRequired(formData.street)) {
    errors.street = 'Street address is required';
  }

  if (!validateRequired(formData.city)) {
    errors.city = 'City is required';
  }

  if (!validateRequired(formData.country)) {
    errors.country = 'Country is required';
  }

  return errors;
};

export const validateHotelStep2 = (formData) => {
  const errors = {};

  if (!formData.hotelImages || formData.hotelImages.length === 0) {
    errors.hotelImages = 'At least one image is required';
  }

  return errors;
};

export const validateHotelStep3 = (formData) => {
  const errors = {};

  if (!validateRequired(formData.description)) {
    errors.description = 'Description is required';
  }

  if (!formData.rules || formData.rules.length === 0) {
    errors.rules = 'At least one rule must be selected';
  }

  if (formData.contactEmail && !validateEmail(formData.contactEmail)) {
    errors.contactEmail = 'Please enter a valid email';
  }

  if (formData.website && !validateURL(formData.website)) {
    errors.website = 'Please enter a valid URL';
  }

  return errors;
};
